import React, { useEffect, useRef } from 'react';
import { useSettings } from '../context/SettingsContext';

const FPSCounter = () => {
    const { settings } = useSettings();
    const counterRef = useRef(null);

    useEffect(() => {
        if (!settings.fpsDisplayEnabled) return;

        let frameCount = 0;
        let lastTime = performance.now();
        let lastFpsUpdate = lastTime;

        const update = () => {
            const now = performance.now();
            frameCount++;

            if (now - lastFpsUpdate >= 1000) {
                const fps = (frameCount / (now - lastFpsUpdate)) * 1000;
                if (counterRef.current) {
                    counterRef.current.textContent = 'FPS: ' + fps.toFixed(1);
                }
                frameCount = 0;
                lastFpsUpdate = now;
            }

            animationFrameId = requestAnimationFrame(update);
        };

        let animationFrameId = requestAnimationFrame(update);
        return () => cancelAnimationFrame(animationFrameId);
    }, [settings.fpsDisplayEnabled]);

    if (!settings.fpsDisplayEnabled) return null;

    return (
        <div id="fps-counter" ref={counterRef}>
            FPS: –
        </div>
    );
};

export default FPSCounter;
